<template>
  <div class="woocommerce-order">
    <h2 class="woocommerce-notice notice-warning-msg">
      {{ $t('checkoutDeclined') }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'OrderFailure',
}
</script>

<style></style>
